  import React from "react";
  import { addLocaleData, IntlProvider } from "react-intl";

  import * as pt from "react-intl/locale-data/pt";

  import ptMessages from "./messages/pt";

  const allMessages = {
    pt: ptMessages
  };

  addLocaleData([...pt]);

  export default function I18nProvider({ children }) {
    const locale = "pt";
    /*useSelector(({ i18n }) => {
      return i18n.lang;
    });*/

    const messages = allMessages[locale];

    return (
        <IntlProvider locale={locale} messages={messages}>
          {children}
        </IntlProvider>
    );
  }
